import { render } from "@/components/pages/suSystemTable/SuSystemTable.html?vue&type=template&id=0ecd965f&external"
import script from "@/components/pages/suSystemTable/SuSystemTable.js?vue&type=script&lang=js&external"
export * from "@/components/pages/suSystemTable/SuSystemTable.js?vue&type=script&lang=js&external"

import "@/components/pages/suSystemTable/SuSystemTable.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__